module.exports = __webpack_public_path__ + "static/img/kjdy3.c474ba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy3.png
// module id = 338
// module chunks = 0